import React, { ReactNode } from 'react';
import { EventsProvider } from '@jbhi-fi/components/src/context/Events/EventsProvider';
import { algoliaEventHandlers } from './algoliaEventHandlers';

export const ShopifyEventsProvider = ({ children }: { children: ReactNode }) => {
  return <EventsProvider eventHandlers={[algoliaEventHandlers]}>{children}</EventsProvider>;
};
